import React from 'react';
import { Link } from 'react-router-dom';
import './RelationshipGraph.css';

/**
 * Placeholder for the archaeology view per main spec Part 8 line 613.
 * The full archaeology view is specified separately — see
 * docs/story-relationship-graph/story-relationship-graph-archaeology-spec.md
 * (to be written before this view is tasked).
 */
export default function GraphHistoryStub() {
  return (
    <div className="rg-page">
      <div className="rg-history-stub">
        <h2>Story archaeology — coming soon</h2>
        <p>
          The full history & archaeology view is specified separately and not
          yet implemented. It will let you browse abandoned, suspended, and
          superseded relationships and revive material you cut earlier.
        </p>
        <Link to="/graph">← Back to graph</Link>
      </div>
    </div>
  );
}
